<template />

<script>
import mapboxgl from 'maplibre-gl'

export default {
  name: 'MapMarker',
  props: {
    wrapperClass: '',
    position: {},
    map: {
      type: Object
    },
    el: {
      type: Object
    },
    options: {
      type: Object
    },
    draggable: {
      type: Boolean,
      default: true
    },
    offset: {
      type: Array,
      default: [0, 0]
    }
  },
  data: function () {
    return {
      marker: null,
      element: this.el ? document.createElement('div') : null
    }
  },
  watch: {
    position: function () {
      // Redraw on props changes
      this.marker.setLngLat(this.position)
    },
    el: function (newValue, oldValue) {
      if (newValue.isEqualNode(oldValue)) {
        return
      }
      const el = this.marker.getElement()
      el.innerHTML = ''
      el.appendChild(this.el)
    }
  },
  created() {
    this.createMarker()
  },
  beforeUnmount() {
    if (this.marker) {
      this.marker.remove()
    }
  },
  methods: {
    createMarker() {
      if (this.el) {
        this.element.classList.add(this.wrapperClass)
        this.element.appendChild(this.el)

        // Add event listeners
        this.element.addEventListener('mouseenter', (event) => this.$emit('mouseenter', event))
        this.element.addEventListener('dblclick', (event) => this.$emit('dblclick', event))
        this.element.addEventListener('mousedown', (event) => this.$emit('mousedown', event))
        this.element.addEventListener('click', (event) => this.$emit('click', event))
        this.element.addEventListener('contextmenu', (event) => this.$emit('contextmenu', event))
      }

      const parameters = {
        ...{
          draggable: this.draggable,
          color: '#E3400A'
        },
        ...this.options
      }
      this.marker = new mapboxgl.Marker({ element: this.element, ...parameters })
        .setLngLat(this.position)
        .addTo(this.map)

      this.marker.on('dragend', (event) => this.$emit('dragend', event))
      this.marker.on('dragstart', (event) => this.$emit('dragstart', event))
      this.marker.setOffset(this.offset)
    }
  },
  render: function () {
    return document.createElement('div')
  }
}
</script>
